var map = {
	"./be/translation.json": 826,
	"./cs/translation.json": 827,
	"./de/translation.json": 828,
	"./en/translation.json": 829,
	"./fr/translation.json": 830,
	"./hy/translation.json": 831,
	"./ka/translation.json": 832,
	"./kk/translation.json": 833,
	"./ru/translation.json": 834,
	"./tg/translation.json": 835,
	"./tr/translation.json": 836,
	"./zh/translation.json": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1698;